module.exports = __webpack_public_path__ + "static/media/templates.bb9f1500.svg";